import React from "react";
import { Link } from "react-router-dom";
//import MapData from "./MapData";
import Paginate from "../../shared/Paginate";
import Loader from "../../Loader/LoaderSection";

import Slider from "react-slick";

// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MapYUP from "./MapYUP";
import MapYUV from "./MapYUV";

// const displayDates = items => {
//     if (Array.isArray(items) || items.length > 0) {
//         return items.map((item, i) => {
//             return (
//                 <p key={i}>
//                     <Link to={`/dashboard/my-updates/year/${item.Year}`}>
//                         {item.Year}
//                     </Link>
//                 </p>
//             );
//         });
//     }
// };

const projects = (items, change) => {
    if (items.length < 1) return;

    const values = items.map(item => {
        return (
            <option value={item.id} key={item.id}>
                {item.project_name}
            </option>
        );
    });

    return (
        <select className="form-control" onChange={change}>
            {values}
        </select>
    );
};

const MyUpdatesV2 = props => {
    function displayYUP() {
        if (props.loading === true) {
            return <Loader />;
        } else {
            return <MapYUP items={props.items} />
        }
    }

    function displayYUV() {
        if (props.loading === true) {
            return <Loader />;
        } else {
            return <MapYUV items={props.items} />
        }
    }

    return (
        <div className="row">
            <div className="donor-column col-sm-9">
                <div className="my-updates-columns text-left panel panel-default">
                    <div className="panel-body">
                        <h1 className="mb-2">Community Update Photo</h1>
                        {displayYUP()}
                    </div>
                </div>

                <div className="panel panel-default text-left ">
                    <div className="panel-body">
                        <h1 className="mb-2">Community Update Videos</h1>
                    
                        {displayYUV()}
                    </div>
                </div>
            </div>

            <div className="donor-column col-sm-3">
                <div className="my-updates-years mt-0">
                    <p>
                        <Link to={`/dashboard/my-updates`} className="active">
                            Recent
                        </Link>
                    </p>

                    <br />

                    <p>Filter updates by project</p>
                    {projects(props.projects, props.change)}

                    {/* {displayDates(props.communityYears)} */}
                </div>
            </div>
        </div>
    );
};

export default MyUpdatesV2;
